import { FormControlLabel, Switch, Typography, Box } from "@mui/material";

export function BooleanAnswer({ label, value = false }) {
  return (
    <Box mb={2}>
      <Typography fontWeight="medium" mb={0.5}>
        {label}
      </Typography>
      <FormControlLabel
        control={<Switch checked={value} />}
        label={value ? "Yes" : "No"}
      />
    </Box>
  );
}
